/* NOVITUAL slideshow behaviour. No dependencies. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.nvReady) return;
    root.dataset.nvReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.nv-ss__slide'));
    if (slides.length === 0) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('.nv-ss__dot'));
    var prev = root.querySelector('.nv-ss__nav--prev');
    var next = root.querySelector('.nv-ss__nav--next');
    var pause = root.querySelector('.nv-ss__pause');
    var live = root.querySelector('.nv-ss__live');

    var index = 0;
    var timer = null;
    var paused = false;
    var delay = parseInt(root.dataset.speed, 10) || 6000;
    var auto = root.dataset.autoplay === 'true' && slides.length > 1 && !reduce;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        // keep offscreen slides out of the tab order
        s.querySelectorAll('a, button').forEach(function (el) {
          el.tabIndex = on ? 0 : -1;
        });
      });
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
      if (live) live.textContent = 'Slide ' + (index + 1) + ' of ' + slides.length;
    }

    function start() {
      if (!auto || paused) return;
      stop();
      timer = setInterval(function () { show(index + 1); }, delay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { show(n); start(); });
    });

    if (pause) {
      pause.addEventListener('click', function () {
        paused = !paused;
        root.classList.toggle('is-paused', paused);
        pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        if (paused) stop(); else start();
      });
    }

    // pause while hovered or focused, and when the tab is hidden
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // keyboard
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(index - 1); start(); }
      if (e.key === 'ArrowRight') { show(index + 1); start(); }
    });

    // touch swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { show(index + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    }, { passive: true });

    show(0);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-nv-slideshow]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // re-init when the theme editor re-renders the section
  document.addEventListener('shopify:section:load', boot);
})();
